<template>
  <div class="contents">
    <top></top>
    <sub-dialog :visible="subdialogvis"></sub-dialog>
  </div>
</template>
<script>
import top from "./components/top.vue";
export default {
  data() {
    return {};
  },
  mounted() {},
  computed: {
    subdialogvis() {
      return this.$store.state.userStore.packageInfo.isMember;
    },
  },
  components: {
    top,
  },
  methods: {},
};
</script>
<style scoped></style>
